export default "__VITE_ASSET__S7YiJLm___"